import $ from "jquery";
import globals from "../globals";
import { readAPIErrorMessage } from "../helper/api_helper";

export function postComment(id, comment, list) {
  let hasCanceled_ = false;
  console.log(list);
  var url = globals.baseAPI + "questions/" + id;
  if (list) url += `?list=${list.name}`;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      type: "POST",
      data: comment,
      success: function(res) {
        if (!hasCanceled_) {
          resolve({
            answer: res.answer,
            errors: "",
            loaded: true
          });
        }
      },
      error: function(data) {
        if (!hasCanceled_) {
          reject({
            answer: null,
            errors: readAPIErrorMessage(data),
            loaded: true
          });
        }
      },
      contentType: false,
      processData: false
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export function postCommentRecommendaton(id, comment) {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: globals.baseAPI + "recommendations/" + id,
      type: "POST",
      data: comment,
      success: function(res) {
        if (!hasCanceled_) {
          resolve({
            answer: res.comment,
            errors: "",
            loaded: true
          });
        }
      },
      error: function(data) {
        if (!hasCanceled_) {
          reject({
            answer: null,
            errors: readAPIErrorMessage(data),
            loaded: true
          });
        }
      },
      contentType: false,
      processData: false
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export function deleteCommentRecommendations(commentId) {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: globals.baseAPI + "comments/" + commentId,
      type: "DELETE",
      success: function(data) {
        if (!hasCanceled_) {
          resolve({
            loaded: true,
            errors: ""
          });
        }
      },
      error: function(data) {
        if (!hasCanceled_) {
          reject({
            loaded: true,
            errors: readAPIErrorMessage(data)
          });
        }
      }
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export function deleteCommentQuestion(answerId) {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: globals.baseAPI + "answers/" + answerId,
      type: "DELETE",
      success: function(data) {
        if (!hasCanceled_) {
          resolve({
            loaded: true,
            errors: ""
          });
        }
      },
      error: function(data) {
        if (!hasCanceled_) {
          reject({
            loaded: true,
            errors: readAPIErrorMessage(data)
          });
        }
      }
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export function editCommentQuestion(answerId, commentfd) {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: globals.baseAPI + "answers/" + answerId,
      type: "PUT",
      data: commentfd,
      contentType: false,
      processData: false,
      success: function(data) {
        if (!hasCanceled_) {
          resolve({
            loaded: true,
            errors: "",
            answer: data.answer
          });
        }
      },
      error: function(data) {
        if (!hasCanceled_) {
          reject({
            loaded: true,
            errors: readAPIErrorMessage(data)
          });
        }
      }
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}



// WEBPACK FOOTER //
// ./src/helper/comment_helper.jsx